import * as Const from 'app/constants/AppConstants';
import { Debugger } from 'springroll';

export default class AspectController {
  constructor(game) {
    this.game = game;
    this.rotateScreen = false;
  }

  updateGameSize(opts) {
    if (this.game.scale) {
      let { width, height } = opts;
      let scale = 1;

      if (height < Const.GAME_SAFE_HEIGHT) {
        scale = height / Const.GAME_SAFE_HEIGHT;
      }
      if (width < Const.GAME_SAFE_WIDTH && scale > width / Const.GAME_SAFE_WIDTH) {
        scale = width / Const.GAME_SAFE_WIDTH;
      }

      if (width > this.game.defaultWidth) {
        width = this.game.defaultWidth;
      } else {
        width = Math.floor(width);
      }
      if (height > this.game.defaultHeight) {
        height = this.game.defaultHeight;
      } else {
        height = Math.floor(height);
      }

      width = Math.floor(width / scale);
      height = Math.floor(height / scale);

      if (width % 2 === 1) {
        width++;
      }

      Debugger.log('log', 'Display size', width, height, ', scale is', scale);

      this.game.screenPadding = Math.max(width, height) * 0.02;
      this.game.scale.setGameSize(width, height);
      this.game.scale.setUserScale(scale);
      this.game.offsetWidth = width / 2 - this.game.defaultWidth / 2;
      this.game.offsetHeight = height / 2 - this.game.defaultHeight / 2;
    }
  }
}
